/**
 * Énumération des niveaux des messages de retour de l'API.
 */
export enum MessageLevel {
    Info = 'Info',
    Success = 'Success',
    Warning = 'Warning',
    Error = 'Error'
}
